import {
  TeamOutlined,
  DollarCircleOutlined,
  CarOutlined,
  HomeOutlined,
  PercentageOutlined,
  UserOutlined,
  PieChartOutlined,
  SolutionOutlined,
  ContactsOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

const dashBoardNavTree = [
  {
    key: "Menu",
    path: "/app",
    title: "sidenav.menu",
    breadcrumb: false,
    submenu: [
      {
        key: "contracts",
        resource: "Shartnoma",
        path: "/app/contracts",
        title: "sidenav.contracts",
        icon: SolutionOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "groups",
        path: "/app/groups",
        resource: "Guruh",
        title: "sidenav.groups",
        icon: TeamOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "transactions",
        path: "/app/transactions",
        resource: "Kirim/Chiqim",
        title: "sidenav.transactions",
        icon: DollarCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "garage",
        path: "/app/garage",
        resource: "Garaj",
        title: "sidenav.garage",
        icon: CarOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "instructors",
        path: "/app/instructors",
        title: "sidenav.instructors",
        resource: "Instruktor",
        icon: ContactsOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const adminNavTree = [
  {
    key: "admin",
    path: "/app",
    title: "sidenav.admin",
    resource: "Admin",
    breadcrumb: false,
    submenu: [
      {
        key: "branch",
        path: "/app/branch",
        title: "sidenav.branch",
        icon: HomeOutlined,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "prices",
        path: "/app/prices",
        title: "sidenav.prices",
        icon: PercentageOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "roles",
        path: "/app/roles",
        title: "sidenav.roles",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "users",
        path: "/app/users",
        title: "sidenav.users",
        icon: UserOutlined,
        breadcrumb: false,
        submenu: [],
      },

      {
        key: "reports",
        path: "/app/reports",
        title: "sidenav.reports",
        icon: PieChartOutlined,
        breadcrumb: false,
        submenu: [],
      },
      {
        key: "lesson-times",
        path: "/app/lesson-times",
        title: "sidenav.lessonTimes",
        resource: "Dars vaqti",
        icon: ClockCircleOutlined,
        breadcrumb: false,
        submenu: [],
      },
    ],
  },
];

const navigationConfig = [...dashBoardNavTree, ...adminNavTree];

export default navigationConfig;
